import { render } from "./Venue2026SpringFall.vue?vue&type=template&id=24a6b97c"
import script from "./Venue2026SpringFall.js?vue&type=script&lang=js"
export * from "./Venue2026SpringFall.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__